/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hero_Refreshavailablein2Inputs */

const id_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyegaran tersedia dalam`)
};

const ms_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segarkan tersedia dalam`)
};

const da_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opdatering tilgængelig om`)
};

const de_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisierung verfügbar in`)
};

const en_us2_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh available in`)
};

const es_es2_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualización disponible en`)
};

const es_mx2_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualización disponible en`)
};

const fil_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh available sa`)
};

const fr_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualisation disponible dans`)
};

const it_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornamento disponibile tra`)
};

const hu_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frissítés elérhető`)
};

const nl_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vernieuwen beschikbaar over`)
};

const no_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppdatering tilgjengelig om`)
};

const pl_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odświeżanie dostępne za`)
};

const pt_br2_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualização disponível em`)
};

const pt_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualização disponível em`)
};

const ro_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reîmprospătare disponibilă în`)
};

const fi_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitys saatavilla`)
};

const sv_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppdatering tillgänglig om`)
};

const vi_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có thể làm mới trong`)
};

const tr_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yenileme kullanılabilir`)
};

const cs_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovení dostupné za`)
};

const bg_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опресняването е достъпно след`)
};

const ru_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновление доступно через`)
};

const uk_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оновлення доступне через`)
};

const ar_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحديث متاح بعد`)
};

const hi_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिफ्रेश उपलब्ध है`)
};

const th_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รีเฟรชได้ใน`)
};

const ja_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新可能まで`)
};

const zh_cn2_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下次刷新时间`)
};

const zh_hant1_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下次重新整理時間`)
};

const ko_profile_hero_refreshavailablein2 = /** @type {(inputs: Profile_Hero_Refreshavailablein2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새로고침 가능까지`)
};

/**
* | output |
* | --- |
* | "Refresh available in" |
*
* @param {Profile_Hero_Refreshavailablein2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_refreshavailablein2 = /** @type {((inputs?: Profile_Hero_Refreshavailablein2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_Refreshavailablein2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_refreshavailablein2(inputs)
	if (locale === "ms") return ms_profile_hero_refreshavailablein2(inputs)
	if (locale === "da") return da_profile_hero_refreshavailablein2(inputs)
	if (locale === "de") return de_profile_hero_refreshavailablein2(inputs)
	if (locale === "en-US") return en_us2_profile_hero_refreshavailablein2(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_refreshavailablein2(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_refreshavailablein2(inputs)
	if (locale === "fil") return fil_profile_hero_refreshavailablein2(inputs)
	if (locale === "fr") return fr_profile_hero_refreshavailablein2(inputs)
	if (locale === "it") return it_profile_hero_refreshavailablein2(inputs)
	if (locale === "hu") return hu_profile_hero_refreshavailablein2(inputs)
	if (locale === "nl") return nl_profile_hero_refreshavailablein2(inputs)
	if (locale === "no") return no_profile_hero_refreshavailablein2(inputs)
	if (locale === "pl") return pl_profile_hero_refreshavailablein2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_refreshavailablein2(inputs)
	if (locale === "pt") return pt_profile_hero_refreshavailablein2(inputs)
	if (locale === "ro") return ro_profile_hero_refreshavailablein2(inputs)
	if (locale === "fi") return fi_profile_hero_refreshavailablein2(inputs)
	if (locale === "sv") return sv_profile_hero_refreshavailablein2(inputs)
	if (locale === "vi") return vi_profile_hero_refreshavailablein2(inputs)
	if (locale === "tr") return tr_profile_hero_refreshavailablein2(inputs)
	if (locale === "cs") return cs_profile_hero_refreshavailablein2(inputs)
	if (locale === "bg") return bg_profile_hero_refreshavailablein2(inputs)
	if (locale === "ru") return ru_profile_hero_refreshavailablein2(inputs)
	if (locale === "uk") return uk_profile_hero_refreshavailablein2(inputs)
	if (locale === "ar") return ar_profile_hero_refreshavailablein2(inputs)
	if (locale === "hi") return hi_profile_hero_refreshavailablein2(inputs)
	if (locale === "th") return th_profile_hero_refreshavailablein2(inputs)
	if (locale === "ja") return ja_profile_hero_refreshavailablein2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_refreshavailablein2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_refreshavailablein2(inputs)
	return ko_profile_hero_refreshavailablein2(inputs)
});
export { profile_hero_refreshavailablein2 as "profile.hero.refreshAvailableIn" }